import { useRef, useState } from "react";
import "./Carousel.css";
import UploadSection from "../UploadSection"; // Adjust the import path as necessary
import ImageGenerator from "../../../../components/ImageGenerator";
import Resizer from "./components/Resizer"; // Adjust the import path as necessary
import { features, isEmbroideryTrace } from "../../../../config/appVariant";
import { addImage, setBulkMode } from "../../../../redux/slices/BulkConversion";
import { useAppDispatch } from "../../../../redux/store";

const Carousel1 = ({
  setImage64,
  setFileName,
  setRerender,
  rerender,
  fileName,
  isImageGeneratorModalVisible,
  setIsImageGeneratorModalVisible,
}) => {
  const fileInputRef = useRef(null); // Reference to hidden file input
  const dispatch = useAppDispatch();



  // Handle file selection
  const handleFileChange = (event) => {
    if (!features.svgEditor) return;
    const files = event.target.files;
    if (files.length < 2) {
      alert("Please select at least 2 images to bulk convert");
      return;
    }
    dispatch(setBulkMode(true)); // Set bulk mode to true
    Array.from(files).forEach((file) => {
      if (["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const imageData = e.target.result;
          dispatch(addImage(imageData)); // Dispatch each image's data
        };

        reader.readAsDataURL(file); // Read each file
      }
    });
  };

  return (
    <div className="upload-container" style={{ textAlign: "center" }}>

      {/* Keep the Resizer component and bulk convert input for functionality */}
      <Resizer />
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/jpeg, image/png, image/webp"
        onChange={handleFileChange}
        multiple={true}
        min={2}
      />
      {!isEmbroideryTrace && <ImageGenerator
        isModalVisible={isImageGeneratorModalVisible} 
        setIsModalVisible={setIsImageGeneratorModalVisible} 
      />}
    </div>
  );
};

export default Carousel1;
